/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import { titleize } from 'underscore.string';
import { withTranslation } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
import { getLoadTypeText } from '../../../load/Loads';
import { sluggify } from '../../../../utils/localization/utils';
const getInitialState = (props) => {
    const { stops: shipmentStops, loads: shipmentLoads } = props;
    const stops = shipmentStops.map((stop) => {
        return {
            action: titleize(stop.action === 'deliver' ? 'delivery' : stop.action),
            loads: stop.loads || [],
        };
    });
    return { stops };
};
class LoadDistributionModal extends Component {
    constructor(props) {
        super(props);
        this.state = getInitialState(props);
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props !== newProps) {
            this.setState(getInitialState(newProps));
        }
    }
    onLoadQuantityChange(stops, stopIndex, loadIndex, value) {
        const stopLoad = Object.assign({}, stops[stopIndex].loads[loadIndex]);
        const shipmentLoad = this.props.loads[loadIndex];
        stopLoad.quantity = parseInt(value || 0, 10);
        stopLoad.weight = parseInt(((shipmentLoad.weight * stopLoad.quantity) /
            shipmentLoad.quantity).toFixed(0), 10);
        stops[stopIndex].loads[loadIndex] = stopLoad;
        this.setState({ stops });
    }
    render() {
        const { loads: shipmentLoads, t } = this.props;
        const { stops } = this.state;
        return (React.createElement(Modal, { show: this.props.show, enforceFocus: false },
            React.createElement(Modal.Header, null,
                React.createElement("h5", null, t('LOAD_DISTRIBUTION'))),
            React.createElement(Modal.Body, null,
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement("div", { className: "pl-4 py-2 font-bold" }, t('OVERALL_CARGO')),
                        React.createElement("ul", null, shipmentLoads.map((l, i) => {
                            return (React.createElement("li", { className: "pl-4", key: i }, `${l.quantity} ${t(getLoadTypeText(l.type), { count: 2 })} ${l.length}x${l.width}x${l.height} ${l.weight} ${t(sluggify(l.weight_units))}`));
                        }))),
                    React.createElement("div", { className: "flex flex-col" },
                        React.createElement("div", { className: "flex flex-row pt-4 pb-2 font-bold" },
                            React.createElement("div", { className: "pl-4 w-1/3" }, t('STOP', { count: 1 })),
                            React.createElement("div", { className: "w-2/3" }, t('LOAD_DISTRIBUTION'))),
                        stops.map((stop, stopIndex) => {
                            return stop.loads.map((l, i) => {
                                return (React.createElement("div", null,
                                    React.createElement("div", { className: "flex flex-row", key: i },
                                        React.createElement("div", { className: "pl-4 w-1/3" },
                                            i === 0 && React.createElement("div", null, t(sluggify(stop.action))),
                                            i > 0 && React.createElement("div", null)),
                                        React.createElement("div", { className: "flex flex-row w-2/3" },
                                            React.createElement("div", { className: "w-24" },
                                                React.createElement(CargomaticInput, { type: "number", placeholder: t('QUANTITY'), min: "0", value: l.quantity, onChange: (value) => this.onLoadQuantityChange(stops, stopIndex, i, value), hideLabel: true })),
                                            React.createElement("div", { className: "pt-2 px-2" }, `${t(getLoadTypeText(l.type), { count: 2 })} ${l.length}x${l.width}x${l.height}`))),
                                    i === stop.loads.length - 1 && (React.createElement("div", { className: "pb-3 mt-2 border-t border-solid border-grey" }))));
                            });
                        })))),
            React.createElement(Modal.Footer, null,
                React.createElement("button", { className: "button", onClick: this.props.onClose }, t('CANCEL')),
                React.createElement("button", { className: "button button-green", onClick: () => this.props.onSave(stops) }, titleize(t('SAVE'))))));
    }
}
LoadDistributionModal.propTypes = {
    stops: PropTypes.array.isRequired,
    loads: PropTypes.array.isRequired,
    onSave: PropTypes.func.isRequired,
};
export default withTranslation()(LoadDistributionModal);
